import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import { deleteReview } from '../../../../bridge';
import { __ } from '../../../../helpers/translations';

function DeleteReviewButton({ reviewId, onDeleted }) {
  const [showModal, setShowModal] = useState(false);
  const [inProgress, setInProgress] = useState(false);

  const onClickDelete = async () => {
    setInProgress(true);
    await deleteReview(reviewId);
    setShowModal(false);
    setInProgress(false);
    onDeleted();
  };

  return (
    <>
      <Button
        title={__('G181')}
        size="md"
        variant="light"
        onClick={() => setShowModal(true)}
        disabled={inProgress}
      >
        <FontAwesomeIcon icon={faTrashAlt} />
      </Button>
      <Modal show={showModal} centered onHide={() => setShowModal(false)}>
        <Modal.Header>
          <Modal.Title>{__('G181')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {__('G182')}
          <br />
          <br />
          <strong>{__('G138')}</strong>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={() => setShowModal(false)}>
            {__('G106')}
          </Button>
          <Button variant="danger" disabled={inProgress} onClick={onClickDelete}>
            {__('G107')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

DeleteReviewButton.propTypes = {
  reviewId: PropTypes.string.isRequired,
  onDeleted: PropTypes.func,
};

export default DeleteReviewButton;
